import { getStates, getStatesByLocale } from "@components/commerce/baseForms/helpers/helpers";
import type { CountryCode } from "@config/site/types";

export const getNameFromValue = (value: string, locale: string) => {
    const resolvedCountry = getStatesByLocale(locale);
    if (!resolvedCountry) {
        return "";
    }
    const state = resolvedCountry.find((state) => state.value === value);
    return state ? state.name : "State not found";
};

export const getNameFromCountryValue = (value: string, country: CountryCode, locale: string) => {
    const resolvedCountry = getStates(country, locale);
    if (!resolvedCountry) {
        return "";
    }
    const state = resolvedCountry.find((state) => state.value === value);
    return state ? state.name : "State not found";
};
